export default __webpack_public_path__ + "static/media/background_image_black.63808d49.png";